import React from "react";
import styled from "styled-components";
import _ from "lodash";
import { connect } from "formik";
import { AutoCompleteInput } from "components/Global/FastFormikMaterial";

import ViewOnlyDiv from "./ViewOnlyDiv";
import LateralField from "./LateralField";

const SideLabelAutoCompleteInput = ({ label, fieldName, formik, isDisabled, options, selectName, selectValue, shouldHideForQuote, ...otherProps }) => {
  if (shouldHideForQuote) {
    return null;
  }

  const { values } = formik;
  if (!selectName) {
    selectName = "name";
  }
  const val = _.get(formik.values, fieldName);
  let selectVal = _.find(options, { [selectValue]: val });
  if (!selectVal) {
    selectVal = { name: "--" };
  }

  return (
    <LateralField label={label}>
      {isDisabled && <ViewOnlyDiv>{selectVal.name}</ViewOnlyDiv>}
      {!isDisabled && <AutoCompleteInput
        formik={formik}
        fieldName={fieldName}
        options={options}
        selectName={selectName}
        selectValue={selectValue}
        {...otherProps}
      />}
    </LateralField>
  );
};
export default connect(SideLabelAutoCompleteInput);
